var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundEggs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 135,
    viewBox: "0 0 245 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99955 22C1.99955 28.6274 7.36917 34 13.9929 34C20.6167 34 25.9863 28.6274 25.9863 22C25.9863 15.3726 20.6167 2 13.9929 2C7.36917 2 1.99955 15.3726 1.99955 22Z",
    fill: "#F7F6EE",
    stroke: "#208C72",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9995 22C32.9995 28.6274 38.3692 34 44.9929 34C51.6167 34 56.9863 28.6274 56.9863 22C56.9863 15.3726 51.6167 2 44.9929 2C38.3692 2 32.9995 15.3726 32.9995 22Z",
    stroke: "#F28520",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9995 22C63.9996 28.6274 69.3692 34 75.9929 34C82.6167 34 87.9863 28.6274 87.9863 22C87.9863 15.3726 82.6167 2 75.9929 2C69.3692 2 63.9995 15.3726 63.9995 22Z",
    fill: "#F7F6EE",
    stroke: "#EA1763",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9995 22C94.9995 28.6274 100.369 34 106.993 34C113.617 34 118.986 28.6274 118.986 22C118.986 15.3726 113.617 2 106.993 2C100.369 2 94.9995 15.3726 94.9995 22Z",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126 22C126 28.6274 131.369 34 137.993 34C144.617 34 149.986 28.6274 149.986 22C149.986 15.3726 144.617 2 137.993 2C131.369 2 126 15.3726 126 22Z",
    fill: "#F7F6EE",
    stroke: "#208C72",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157 22C157 28.6274 162.369 34 168.993 34C175.617 34 180.986 28.6274 180.986 22C180.986 15.3726 175.617 2 168.993 2C162.369 2 157 15.3726 157 22Z",
    fill: "#F7F6EE",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188 22C188 28.6274 193.369 34 199.993 34C206.617 34 211.986 28.6274 211.986 22C211.986 15.3726 206.617 2 199.993 2C193.369 2 188 15.3726 188 22Z",
    fill: "#F7F6EE",
    stroke: "#F28520",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219 22C219 28.6274 224.369 34 230.993 34C237.617 34 242.986 28.6274 242.986 22C242.986 15.3726 237.617 2 230.993 2C224.369 2 219 15.3726 219 22Z",
    fill: "#F7F6EE",
    stroke: "#EA1763",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99955 62C1.99955 68.6274 7.36917 74 13.9929 74C20.6167 74 25.9863 68.6274 25.9863 62C25.9863 55.3726 20.6167 42 13.9929 42C7.36917 42 1.99955 55.3726 1.99955 62Z",
    stroke: "#208C72",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99955 102C1.99955 108.627 7.36917 114 13.9929 114C20.6167 114 25.9863 108.627 25.9863 102C25.9863 95.3726 20.6167 82 13.9929 82C7.36917 82 1.99955 95.3726 1.99955 102Z",
    fill: "#F7F6EE",
    stroke: "#EA1763",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99955 142C1.99955 148.627 7.36917 154 13.9929 154C20.6167 154 25.9863 148.627 25.9863 142C25.9863 135.373 20.6167 122 13.9929 122C7.36917 122 1.99955 135.373 1.99955 142Z",
    fill: "#F7F6EE",
    stroke: "#F28520",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9995 102C32.9996 108.627 38.3692 114 44.9929 114C51.6167 114 56.9863 108.627 56.9863 102C56.9863 95.3726 51.6167 82 44.9929 82C38.3692 82 32.9995 95.3726 32.9995 102Z",
    fill: "#F7F6EE",
    stroke: "#208C72",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9995 62C32.9995 68.6274 38.3692 74 44.9929 74C51.6167 74 56.9863 68.6274 56.9863 62C56.9863 55.3726 51.6167 42 44.9929 42C38.3692 42 32.9995 55.3726 32.9995 62Z",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9995 142C32.9996 148.627 38.3692 154 44.9929 154C51.6167 154 56.9863 148.627 56.9863 142C56.9863 135.373 51.6167 122 44.9929 122C38.3692 122 32.9995 135.373 32.9995 142Z",
    fill: "#F7F6EE",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9995 62C63.9996 68.6274 69.3692 74 75.9929 74C82.6167 74 87.9863 68.6274 87.9863 62C87.9863 55.3726 82.6167 42 75.9929 42C69.3692 42 63.9995 55.3726 63.9995 62Z",
    fill: "#F7F6EE",
    stroke: "#F28520",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9995 102C63.9996 108.627 69.3692 114 75.9929 114C82.6167 114 87.9863 108.627 87.9863 102C87.9863 95.3726 82.6167 82 75.9929 82C69.3692 82 63.9995 95.3726 63.9995 102Z",
    fill: "#F7F6EE",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9995 142C63.9996 148.627 69.3692 154 75.9929 154C82.6167 154 87.9863 148.627 87.9863 142C87.9863 135.373 82.6167 122 75.9929 122C69.3692 122 63.9995 135.373 63.9995 142Z",
    fill: "#F7F6EE",
    stroke: "#F28520",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9995 62C94.9996 68.6274 100.369 74 106.993 74C113.617 74 118.986 68.6274 118.986 62C118.986 55.3726 113.617 42 106.993 42C100.369 42 94.9995 55.3726 94.9995 62Z",
    fill: "#F7F6EE",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M125.986 102C125.986 108.627 131.356 114 137.979 114C144.603 114 149.973 108.627 149.973 102C149.973 95.3726 144.603 82 137.979 82C131.355 82 125.986 95.3726 125.986 102Z",
    fill: "#F7F6EE",
    stroke: "#208C72",
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9995 142C94.9996 148.627 100.369 154 106.993 154C113.617 154 118.986 148.627 118.986 142C118.986 135.373 113.617 122 106.993 122C100.369 122 94.9995 135.373 94.9995 142Z",
    fill: "#F7F6EE",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126 62C126 68.6274 131.369 74 137.993 74C144.617 74 149.986 68.6274 149.986 62C149.986 55.3726 144.617 42 137.993 42C131.369 42 126 55.3726 126 62Z",
    stroke: "#F28520",
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9995 102C94.9996 108.627 100.369 114 106.993 114C113.617 114 118.986 108.627 118.986 102C118.986 95.3726 113.617 82 106.993 82C100.369 82 94.9995 95.3726 94.9995 102Z",
    fill: "#F7F6EE",
    stroke: "#F28520",
    strokeWidth: 3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126 142C126 148.627 131.369 154 137.993 154C144.617 154 149.986 148.627 149.986 142C149.986 135.373 144.617 122 137.993 122C131.369 122 126 135.373 126 142Z",
    fill: "#F7F6EE",
    stroke: "#208C72",
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157 62C157 68.6274 162.369 74 168.993 74C175.617 74 180.986 68.6274 180.986 62C180.986 55.3726 175.617 42 168.993 42C162.369 42 157 55.3726 157 62Z",
    fill: "#F7F6EE",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157 102C157 108.627 162.369 114 168.993 114C175.617 114 180.986 108.627 180.986 102C180.986 95.3726 175.617 82 168.993 82C162.369 82 157 95.3726 157 102Z",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157 142C157 148.627 162.369 154 168.993 154C175.617 154 180.986 148.627 180.986 142C180.986 135.373 175.617 122 168.993 122C162.369 122 157 135.373 157 142Z",
    fill: "#F7F6EE",
    stroke: "#208C72",
    strokeWidth: 3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M188 62C188 68.6274 193.369 74 199.993 74C206.617 74 211.986 68.6274 211.986 62C211.986 55.3726 206.617 42 199.993 42C193.369 42 188 55.3726 188 62Z",
    fill: "#F7F6EE",
    stroke: "#EA1763",
    strokeWidth: 3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188 102C188 108.627 193.369 114 199.993 114C206.617 114 211.986 108.627 211.986 102C211.986 95.3726 206.617 82 199.993 82C193.369 82 188 95.3726 188 102Z",
    fill: "#F7F6EE",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M188 142C188 148.627 193.369 154 199.993 154C206.617 154 211.986 148.627 211.986 142C211.986 135.373 206.617 122 199.993 122C193.369 122 188 135.373 188 142Z",
    fill: "#F7F6EE",
    stroke: "#3360AD",
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M219 62C219 68.6274 224.369 74 230.993 74C237.617 74 242.986 68.6274 242.986 62C242.986 55.3726 237.617 42 230.993 42C224.369 42 219 55.3726 219 62Z",
    stroke: "#208C72",
    strokeWidth: 3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M219 102C219 108.627 224.369 114 230.993 114C237.617 114 242.986 108.627 242.986 102C242.986 95.3726 237.617 82 230.993 82C224.369 82 219 95.3726 219 102Z",
    fill: "#F7F6EE",
    stroke: "#F28520",
    strokeWidth: 3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M219 142C219 148.627 224.369 154 230.993 154C237.617 154 242.986 148.627 242.986 142C242.986 135.373 237.617 122 230.993 122C224.369 122 219 135.373 219 142Z",
    fill: "#F7F6EE",
    stroke: "#F28520",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEggs2);
export default __webpack_public_path__ + "static/media/background-eggs-2.22bae933f210b3e6bc58d4e3deec0814.svg";
export { ForwardRef as ReactComponent };